import * as React from 'react'
import { StyledSectionContainer, ModuleContentContainer, SecondaryTitle, TertiaryTitle } from '../shared/section'
import { colors } from '../../../utils/helpers/colors'
import LinkList from '../shared/LinkList'

const AdjacentCitiesModule = ({ links }) => (
  <StyledSectionContainer backgroundColor={colors.white} data-testid="section-container-pp">
    <SecondaryTitle data-testid="secondary-title-pp">
      <b>Élargissez</b> votre recherche
    </SecondaryTitle>
    <TertiaryTitle data-testid="tertiary-title-pp">Villes à proximité</TertiaryTitle>
    <ModuleContentContainer data-testid="module-content-pp">
      <LinkList links={links} wording={{ plural: 'villes' }} maxLinks={10} />
    </ModuleContentContainer>
  </StyledSectionContainer>
)

export default AdjacentCitiesModule
